import { render, staticRenderFns } from "./StockListPurchaseOrders.vue?vue&type=template&id=659140a3"
import script from "./StockListPurchaseOrders.vue?vue&type=script&lang=js"
export * from "./StockListPurchaseOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports